import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  header: {
    display: "flex",
    gap: "1rem",
  },
  toggle: {
    cursor: "pointer",
    color: theme.palette.primary.main,
  },
  clickable: {
    cursor: "pointer",
  },
  types: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "3rem",
    color: theme.palette.text.secondary,
    gap: "0.25rem",
  },
}));

export default useStyles;
